import { Injectable } from '@angular/core';
import {Headers,Http} from "@angular/http";
import {environment} from "../../../environments/environment";
import { NgModel } from '@angular/forms';

@Injectable()
export class CategoryService {
      private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
      constructor(
        private http: Http
      ) { }

      //Fetch All Categorylist registered
      getCategoryList(offset,searchText) {
        let body = "offset="+offset+"&searchText="+searchText+""
        const promise = new Promise((resolve, reject) => {
        const apiURL = environment.BASE_URL+'/categorieslist';
            this.http.post(apiURL,body,{headers: this.headers})
            .toPromise()
            .then(
              res => { // Success
                resolve(res.json());
              }
            ).catch(
            err => {
              console.log(err.json());
              reject(err.json());
            }
          );
        });
        return promise;
      }

    //Fetch single category information
    getCategoryInfo(iCategoryId){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/categoryinfo/'+iCategoryId;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    //Delete Category
    deleteCategoryCall(iCategoryId){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/deletecategory/'+iCategoryId;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    createCategory(categoryValue){
        const promise = new Promise((resolve, reject) => {
            let body = "name="+categoryValue.name+"&is_locked="+categoryValue.is_locked+"&image="+categoryValue.image;
            const apiURL = environment.BASE_URL+'/category/create';
            this.http.post(apiURL,body,{headers: this.headers})
                .toPromise()
                .then(
                    res => { // Success
                        //console.log(res.json());
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    updateCategory(categoryValue){
        const promise = new Promise((resolve, reject) => {
            let body = "name="+categoryValue.name+"&category_id="+categoryValue.category_id+"&is_locked="+categoryValue.is_locked+"&image="+categoryValue.image;
            const apiURL = environment.BASE_URL+'/category/update';
            this.http.post(apiURL,body,{headers: this.headers})
                .toPromise()
                .then(
                    res => { // Success
                        //console.log(res.json());
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/categoriesmaster/services/category.service.ts